import { Moment } from "moment"
import { IUpdatePathParamsParams } from "hooks/useUpdatePathParams"
import { CalendarModes } from "./types"

interface IUpdatePlanningPathParamsForDatePayload {
  date: Moment
  mode?: CalendarModes
}
interface IUpdatePlanningPathParamsForDateReturnValue extends IUpdatePathParamsParams {
  year: string
  week: string
  weekday?: string
}

export function updatePlanningPathParamsForDate({
  date,
  mode,
}: IUpdatePlanningPathParamsForDatePayload): IUpdatePlanningPathParamsForDateReturnValue {
  const updatedParams = {
    year: date.format("GGGG"),
    week: date.format("WW"),
    weekday: mode === CalendarModes.DAY ? date.format("E") : undefined,
  }

  return updatedParams
}
